export default __webpack_public_path__ + "static/media/APlogo.b2ca9c53.jpeg";